/* eslint-disable */
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PortSummaryCard from '../../components/PortSummaryCard/PortSummaryCard';
import { openStartManyForStation, resolveStartManyPorts } from './openStartManyForStation';

/** Port summary card — opens startMany for all ports on this device */
export default function ChargingPortCard({
  station,
  stationNumber,
  socPercent = null,
  showCountdown = true,
  style,
  className = '',
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [portCount, setPortCount] = useState(1);

  useEffect(() => {
    let active = true;
    resolveStartManyPorts(station, stationNumber).then(ports => {
      if (active) {
        setPortCount(Math.max(1, ports.length));
      }
    });
    return () => {
      active = false;
    };
  }, [station, stationNumber]);

  const handleOpenStartMany = useCallback(() => {
    openStartManyForStation(navigate, station, stationNumber);
  }, [navigate, station, stationNumber]);

  return (
    <PortSummaryCard
      station={station}
      portNumber={stationNumber}
      portCount={portCount}
      socPercent={socPercent}
      showCountdown={showCountdown}
      className={className}
      style={style}
      ariaLabel={t('portCardOpenStartManyAria', { stationNumber })}
      onClick={handleOpenStartMany}
    />
  );
}
